module.exports = __webpack_public_path__ + "b883107d92ae2fc002f52ea57c7fefb3.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/assets/fonts/hmr.woff
 ** module id = 32
 ** module chunks = 0
 **/